import React from 'react';  
import Select from 'react-select';    
import { useDebouncedCallback } from 'use-debounce';

const DropDownFilterPaginations = ({ options, defaultText, value, onchange, paramkey, search }) => {  

  const language = localStorage.getItem("i18nextLng");

    const handleChange = (selectedOption) => {  
        const selectedValue = selectedOption ? selectedOption.value : null;  
        
        if (onchange) {  
            onchange(selectedValue);  
        }  
    };  

    const handleInputChange = useDebouncedCallback ((inputValue) => {  
        search(inputValue);  
    },1000);  

    const formattedOptions = (options || []).map((e) => ({
        value: String(e.id),
        label: language == "en" ? e.name.en : e.name.ar ,
    }));

    const selectedValue = value != null ? String(value) : null;
    const selectedOption = formattedOptions.find((opt) => opt.value === selectedValue) ?? null;

    return (  
        <>  
    <Select
      name={paramkey}
      options={formattedOptions}
      placeholder={defaultText}
      onInputChange={handleInputChange}
      onChange={handleChange}
      className="w-full bg-thirdly border border-gray-500/100 rounded-md"
      // required
      value={selectedOption}
      isSearchable={true}
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: "#212529",
          color: "white",
          height: 40,
          minHeight: 40,
          border: "none",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "white",
        }),
        singleValue: (provided) => ({
          ...provided,
          color: "white",
        }),
        input: (provided) => ({
          ...provided,
          color: "white",
        }),
      }}
    />
        </>  
    );  
};  

export default DropDownFilterPaginations;